import { render, staticRenderFns } from "./game-option.vue?vue&type=template&id=5c940157&"
import script from "./game-option.vue?vue&type=script&lang=js&"
export * from "./game-option.vue?vue&type=script&lang=js&"
import style0 from "./game-option.vue?vue&type=style&index=0&id=5c940157&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports